import { motion } from "framer-motion";
import { useLanguage } from "../../context/LanguageContext";

export const Manifesto = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="manifesto-section" className="py-28 md:py-36 max-w-7xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-20"
      >
        <p className="font-mono-tech text-xs tracking-[0.25em] uppercase text-[#60A5FA] mb-6" data-testid="manifesto-overline">
          {t.manifesto.overline}
        </p>
        <h2 className="font-display font-bold tracking-tight leading-[1.05] text-4xl md:text-5xl lg:text-6xl" data-testid="manifesto-title">
          {t.manifesto.title}
        </h2>
      </motion.div>

      <div>
        {t.manifesto.chapters.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.05 * i }}
            data-testid={`manifesto-chapter-${i}`}
            className="group grid md:grid-cols-12 gap-6 py-12 border-t border-white/10 last:border-b items-start"
          >
            <div className="md:col-span-2 font-mono-tech text-sm text-[#2563EB] pt-2">/{c.num}</div>
            <h3 className="md:col-span-6 font-display font-bold tracking-tight leading-[1.05] text-3xl md:text-5xl group-hover:text-[#60A5FA] transition-colors duration-500">
              {c.title}
            </h3>
            <p className="md:col-span-4 text-slate-400 text-base leading-relaxed md:pt-2">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
